import React from 'react'
import { createUseStyles } from 'react-jss'

import { forPhoneOnly, forTabletLandscapeUp } from 'src/config/mediaQueries'

const useStyles = createUseStyles(
  {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& > div + div': {
        marginTop: 16,
        [forPhoneOnly]: {
          marginTop: 16,
        },
      },
      [forTabletLandscapeUp]: {
        display: 'inline-flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        /**
         * Due to the structure of the input elements,
         * we were selecting all children and setting
         * the width
         */
        '& > div': {
          width: '100%',
        },
        '& > div + div': {
          marginLeft: 24,
          marginTop: 0,
        },
      },
    },
  },
  { name: 'PatientNameWrapper' }
)

type Props = {
  children: React.ReactNode
}

const PatientNameWrapper: React.FC<Props> = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.root}>{children}</div>
}

export default PatientNameWrapper
